const defaultDesktopMenu = [
    {
        "text": "Кредиты",
        "href": "/kredity/onlajn-zayavka-na-kredit/",
        "isLink": true,
        "nofollow": false,
        "noReferrer": false,
        "noindex": false,
        "openInNew": false,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Подбор кредита",
                        "href": "/kredity/onlajn-zayavka-na-kredit/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Wallet.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредитный рейтинг",
                        "href": "/kredity/scoring/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Scoring.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Потребительские кредиты",
                        "href": "/kredity/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Orders.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рефинансирование",
                        "href": "/kredity/refinansirovanie/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Exchange.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Автокредиты",
                        "href": "/avtokredity/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Car.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредитный калькулятор",
                        "href": "/kredity/kalkuljator/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/LoanCalc.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Кредиты наличными",
                        "href": "/kredity/nalichnymi/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/MoneyCoins.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредиты онлайн",
                        "href": "/kredity/na-kartu-bez-poseshhenija-banka/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/PhoneDownload.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Банкротство",
                        "href": "/bankrotstvo/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ChartDown.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредиты без справок о доходах",
                        "href": "/kredity/bez-spravok-o-dokhodakh/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/LoanDocument.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредиты под залог недвижимости",
                        "href": "/kredity/pod-zalog-nedvizhimosti/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/InterfaceHome.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредиты с плохой кредитной историей",
                        "href": "/kredity/s-plohoy-istoriey/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ChartDown.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Курсы обмена валют",
                        "href": "/valjuty/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рейтинг банков",
                        "href": "/banki/rating/klientskij/?productCategory=natural",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список банков",
                        "href": "/banki/ ",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о банках",
                        "href": "/banki/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Страхование",
        "href": "/strahovanie/",
        "isLink": true,
        "nofollow": false,
        "noReferrer": false,
        "noindex": false,
        "openInNew": false,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "ОСАГО",
                        "href": "/osago/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Car.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Каско",
                        "href": "/kasko/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Car.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование ипотеки",
                        "href": "/strahovanie-ipoteki/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/HouseSafety.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование путешественников",
                        "href": "/vzr/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Plane.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование квартиры",
                        "href": "/strahovanie-nedvizhimosti/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ShieldSafety.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Страхование спортсменов",
                        "href": "/strahovanie-ns/sportivnaya/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/PrizeCup.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Добровольное медицинское страхование",
                        "href": "/dms/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Stethoscope.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "От критических заболеваний",
                        "href": "/strahovka-kriticheskie-bolezni/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Lungs.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование от укуса клеща",
                        "href": "/strahovka-ot-klescha/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Bug.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование дома и дачи",
                        "href": "/strahovanie-domov/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/InsuranceHouse.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование животных",
                        "href": "/strahovanie-zhivotnih/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/AnimalInsurance.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Проверка КБМ",
                        "href": "/osago/proverka-kbm/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рейтинг страховых компаний",
                        "href": "/strakhovye-kompanii/rating/klientskij/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список страховых компаний",
                        "href": "/strakhovye-kompanii/ ",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о страховых компаниях",
                        "href": "/strakhovye-kompanii/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Статьи о страховании",
                        "href": "/novosti/rubrika/strahovki/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Займы",
        "href": "/zaimy/",
        "isLink": true,
        "nofollow": false,
        "noReferrer": false,
        "noindex": false,
        "openInNew": false,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Займы онлайн",
                        "href": "/zaimy/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/PhoneDownload.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы на карту",
                        "href": "/zaimy/na-kartu/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CreditCard.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы без отказа",
                        "href": "/zaimy/na-kartu-bez-otkazov/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ThumbUp.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы с плохой КИ",
                        "href": "/zaimy/s-plokhoj-kreditnoj-istoriej/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ChartDown.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы без процентов",
                        "href": "/zaimy/bez-protsentov/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Percent.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Банкротство",
                        "href": "/bankrotstvo/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ChartDown.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Лучшие займы",
                        "href": "/zaimy/top/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Fire.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы под залог ПТС",
                        "href": "/zaimy/pod-pts/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Car.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы через Госуслуги",
                        "href": "/zaimy/cherez-gosuslugi/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Fingerprint.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы до зарплаты",
                        "href": "/zaimy/na-kartu-do-zarplaty/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/MyCredits.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Долгосрочные займы",
                        "href": "/zaimy/dolgosrochnye/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CalendarSimple.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Займы с просрочками",
                        "href": "/zaimy/s-prosrochkami/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CCFast.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Рейтинг МФО",
                        "href": "/zaimy/rating-mfo/?userRatingType=all",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список МФО",
                        "href": "/zaimy/mfo/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы об МФО",
                        "href": "/zaimy/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Ипотека",
        "href": "/ipoteka/",
        "isLink": true,
        "nofollow": false,
        "noReferrer": false,
        "noindex": false,
        "openInNew": false,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Ипотечные кредиты",
                        "href": "/ipoteka/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/House.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Заявка на ипотеку онлайн",
                        "href": "https://www.cian.ru/ipoteka-main/?utm_source=sravni&utm_medium=cpa&utm_campaign=sravni_zayavka_online&utm_content=cian_ipoteka_from_zayavka_online&utm_term=ipoteka_08&sravni_id=%7Btransaction_id%7D/?noreferrer=1",
                        "isLink": true,
                        "nofollow": true,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Online.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Семейная ипотека",
                        "href": "/ipoteka/lgotnaya-gospodderzhkoy/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Family.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Ипотека с господдержкой",
                        "href": "/ipoteka/gosudarstvennaja/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/HouseVacations.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Вторичное жилье",
                        "href": "/ipoteka/zhile-na-vtorichnom-rynke/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Flat.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Новостройки",
                        "href": "/ipoteka/zhile-na-pervichnom-rynke/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/NewFlat.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Строительство дома",
                        "href": "/ipoteka/na-stroitelstvo-doma/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Fence.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рефинансирование ипотеки",
                        "href": "/ipoteka/refinansirovanie-ipoteki/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Exchange.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Калькулятор ипотеки",
                        "href": "/ipoteka/kalkuljator-ipoteki/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CalcHouse.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Ипотека без первоначального взноса",
                        "href": "/ipoteka/bez-pervonachalnogo-vznosa/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/RubleHouse.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Выгодные ставки по ипотеке",
                        "href": "/ipoteka/top/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/PercentHouse.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Ипотека для молодой семьи",
                        "href": "/ipoteka/dlja-molodoj-semi/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Couple.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Военная ипотека",
                        "href": "/ipoteka/voennym/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/StarHouse.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование ипотеки",
                        "href": "/strahovanie-ipoteki/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/HouseSafety.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Оценка недвижимости",
                        "href": "/ocenka-nedvizhimosti/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/HouseSearch3.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Рейтинг банков",
                        "href": "/banki/rating/klientskij/?productCategory=natural&reviewTag=mortgage&userRatingType=all",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список банков",
                        "href": "/banki/?tag=mortgage",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о банках",
                        "href": "/banki/otzyvy/?tag=mortgage",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Карты",
        "href": "/kredity/promo/karty/",
        "isLink": true,
        "nofollow": false,
        "noReferrer": false,
        "noindex": false,
        "openInNew": false,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Подбор кредитной карты",
                        "href": "/kredity/promo/karty/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CreditCardGroupo.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредитные карты",
                        "href": "/karty/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CardTimer.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Дебетовые карты",
                        "href": "/debetovye-karty/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CardPlus.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредитные карты с бесплатным обслуживанием",
                        "href": "/karty/besplatnye/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CCFree.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Виртуальные кредитные карты",
                        "href": "/karty/virtualnye/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CCVirt.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредитные карты с моментальным решением",
                        "href": "/karty/momentalnym-resheniem/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CCFast.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Кредитные карты без отказа",
                        "href": "/karty/bez-otkaza-plohoy-kreditnoy-istoriey/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CCGuaranteed.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредитные карты с доставкой",
                        "href": "/karty/?sub-freeService=freeService&feature=courier",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CardTransfer.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредитные карты без подтверждения дохода",
                        "href": "/karty/bez-spravok-o-dokhodakh/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CCEasy.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Карты рассрочки",
                        "href": "/karty/rassrochki/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CoinRub.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредитные карты с кэшбэком",
                        "href": "/karty/keshbekom/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CreditCashback.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Рейтинг банков",
                        "href": "/banki/rating/klientskij/?productCategory=natural",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список банков",
                        "href": "/banki/ ",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о банках",
                        "href": "/banki/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Вклады",
        "href": "/vklady/",
        "isLink": true,
        "nofollow": false,
        "noReferrer": false,
        "noindex": false,
        "openInNew": false,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Вклады",
                        "href": "/vklady/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Deposit.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Накопительные счета",
                        "href": "/vklady/nakopitelnye/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Percent.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Калькулятор вкладов",
                        "href": "/vklady/kalkuljator/  ",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Calc.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Брокерское обслуживание",
                        "href": "/invest/brokerskoe-obsluzhivanie/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Briefcase.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Инвестиционные вклады",
                        "href": "/invest/investicionnyje-vklady/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/InvestmentDeposits.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Куда вложить деньги",
                        "href": "/promo/bonus/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Star.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Пенсионные программы НПФ",
                        "href": "/invest/npf-programmy/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/PensionSavings.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Инвестиции в бизнес",
                        "href": "/invest/investicii-v-biznes/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CoinRub.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Инвестиции в МФО",
                        "href": "/invest/investicii-v-mfo/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CoinStack.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Инвестиционное страхование жизни",
                        "href": "/invest-strahovanie/iszh/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/InvestmentLifeInsurance.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Накопительное страхование жизни",
                        "href": "/invest-strahovanie/nszh/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CumulativeLifeInsurance.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Рейтинг банков",
                        "href": "/banki/rating/klientskij/?productCategory=natural",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список банков",
                        "href": "/banki/ ",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о банках",
                        "href": "/banki/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рейтинг брокеров",
                        "href": "/brokery/rating/klientskij/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о брокерах",
                        "href": "/brokery/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Бизнес",
        "href": "/biznes/",
        "customStyle": "white-space: nowrap;",
        "isLink": true,
        "nofollow": false,
        "noReferrer": false,
        "noindex": false,
        "openInNew": false,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Лучшие предложения для бизнеса",
                        "href": "/biznes-special/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/IdentityCard.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Расчетно-кассовое обслуживание",
                        "href": "/rko/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CardTerminal.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредиты для бизнеса",
                        "href": "/biznes-kredity/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Briefcase.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Банковские гарантии",
                        "href": "/biznes/bankovskie-garantii/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/MyCredits.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Сервис проверки контрагента",
                        "href": "/kontragent/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ProductsSearch.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Эквайринг",
                        "href": "/biznes/ekvajring/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Acquiring.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "ВЭД",
                        "href": "/biznes-ved/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Handshake.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Регистрация бизнеса",
                        "href": "/biznes-registration/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/BlankStamp.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Лизинг",
                        "href": "/biznes-leasing/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Car.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Бухгалтерские услуги",
                        "href": "/biznes-accounting/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/BusinessAccounting.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Услуги для маркетплейсов",
                        "href": "/biznes-marketplace",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Management.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Внесение изменений в ИП и ООО",
                        "href": "/biznes-vnesenie-izmeneniy/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/CursorSelected.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Ликвидация ИП",
                        "href": "/biznes-likvidaciya/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/FileCrossOut.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Вклады для бизнеса",
                        "href": "/biznes-vklady/",
                        "isLink": true,
                        "nofollow": true,
                        "noReferrer": false,
                        "noindex": true,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Orders.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Рейтинг банков для бизнеса",
                        "href": "/banki/rating/klientskij/?productCategory=legal",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Статьи о бизнесе",
                        "href": "/novosti/teg/biznes/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о банках",
                        "href": "/banki/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Образование",
        "href": "/kursy/",
        "isLink": true,
        "nofollow": false,
        "noReferrer": false,
        "noindex": false,
        "openInNew": false,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Программирование",
                        "href": "/kursy/programmirovanie/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Programming.svg",
                        "isTextVisible": false,
                        "children": []
                    },
                    {
                        "text": "Дизайн",
                        "href": "/kursy/dizajn/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Design.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Управление",
                        "href": "/kursy/menedzhment/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Briefcase.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Аналитика",
                        "href": "/kursy/analitika/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Analytics.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Маркетинг",
                        "href": "/kursy/marketing/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Marketing.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Подготовка к ЕГЭ и ОГЭ",
                        "href": "/ege-oge/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/BookOpen.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Разработка на Python",
                        "href": "/kursy/programmirovanie-python/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Globe.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "1С-программирование",
                        "href": "/kursy/programmirovanie-1s/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Programming1C.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "QA-тестирование",
                        "href": "/kursy/programmirovanie-testirovshchik/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/QA.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Графический дизайн",
                        "href": "/kursy/dizajn-graficheskij/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/GraphicDesign.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Веб-дизайн",
                        "href": "/kursy/dizajn-web/",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/WebDesign.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Английский язык",
                        "href": "/kursy/anglijskij-yazyk/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Bubble.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 3",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Рейтинг курсов",
                        "href": "/kursy/rating/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Отзывы о курсах",
                        "href": "/kursy/otzyvy/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Статьи о курсах",
                        "href": "/novosti/teg/obrazovanie/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": false,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Список школ",
                        "href": "/shkoly/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    },
    {
        "text": "Журнал",
        "href": "/novosti/?showContentWidget=1",
        "isLink": true,
        "nofollow": false,
        "noReferrer": false,
        "noindex": false,
        "openInNew": false,
        "isTextVisible": true,
        "children": [
            {
                "text": "Группа 1",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Главное",
                        "href": "/novosti/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Calculations.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Вопросы и ответы",
                        "href": "/q/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/QnA.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Тесты и игры",
                        "href": "/novosti/teg/testy-i-igry/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Gamepad.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Спецпроекты",
                        "href": "/promo/special-projects/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Rocket.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Новости компаний",
                        "href": "/novosti/rubrika/novosti-partnerov/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Subscriptions.svg",
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Рейтинг экспертов",
                        "href": "/u/rating/",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "icon": "https://s91588.cdn.ngenix.net/shared/icons/PrizeCup.svg",
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            },
            {
                "text": "Группа 2",
                "isLink": false,
                "nofollow": false,
                "noReferrer": false,
                "noindex": false,
                "openInNew": false,
                "isTextVisible": false,
                "children": [
                    {
                        "text": "Карты",
                        "href": "/novosti/rubrika/karty/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Вклады",
                        "href": "/novosti/rubrika/vklady/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Кредиты",
                        "href": "/novosti/rubrika/kredity/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Инвестиции",
                        "href": "/novosti/rubrika/investicii/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Недвижимость",
                        "href": "/novosti/rubrika/nedvizhimost/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    },
                    {
                        "text": "Страхование",
                        "href": "/novosti/rubrika/strahovki/",
                        "customStyle": "color: var(--color-D40);",
                        "isLink": true,
                        "nofollow": false,
                        "noReferrer": false,
                        "noindex": false,
                        "openInNew": false,
                        "isTextVisible": true,
                        "children": []
                    }
                ]
            }
        ]
    }
];

export { defaultDesktopMenu };
//# sourceMappingURL=defaultDesktopMenu.js.map
